export class AttributeRegistry {
}
AttributeRegistry.GeomObjectIndex = 0;
AttributeRegistry.DrawingObjectIndex = 1;
AttributeRegistry.AlgorithmDataIndex = 2;
AttributeRegistry.ViewerIndex = 3;
//# sourceMappingURL=attributeRegistry.js.map